module.exports = __webpack_public_path__ + "media/images/client-3-dc487867b89aee77a3881bc6b8f6448c.png";